import { Fragment } from "react";
import { Grid as MuiGrid, Box as MuiBox } from "@mui/material";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import type { IToken } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";
import { Typography } from "@dzambalaorg/ui-kit";

import { TokenHistory, CommonTokenPanel } from "../../../../components/common";
import { DismantleTokenPanel } from "../../../mechanics/gaming/recipes/dismantle/dismantle-token-panel";
import { RarityTokenPanel } from "../../../mechanics/gaming/rarity/rarity-token-panel";
import { DiscreteTokenPanel } from "../../../mechanics/gaming/discrete/discrete-token-panel";
import { GenesTokenPanel } from "../../../mechanics/gaming/genes/genes-token-panel";
import { TraitTokenPanel } from "../../../mechanics/gaming/traits/traits-token-panel";
import { MysteryTokenPanel } from "../../../mechanics/marketing/mystery/token/mystery-token-panel";
import { LendTokenPanel } from "../../../mechanics/gaming/rent/token-item/lend-token-panel";
import { Erc998Composition } from "./composition";

export const Erc998Token = () => {
  const { data, isLoading, refetch } = useFetchData<IToken>("/erc998/tokens");

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc998", "erc998.token"]} data={[{}, {}, data.template]} />

      <PageHeader message="pages.erc998.token.title" data={data.template} />

      <MuiGrid container>
        <MuiGrid size={{ xs: 12, sm: 9 }}>
          <MuiBox component="img" src={data.template!.imageUrl} alt="Cascadify token image" width={300} height={300} />
          <Typography variant="body2">
            <RichTextDisplay data={data.template!.description} />
          </Typography>
          <Erc998Composition token={data} />
        </MuiGrid>
        <MuiGrid size={{ xs: 12, sm: 3 }}>
          {data.templateId && (
            <>
              <CommonTokenPanel token={data} />
              <RarityTokenPanel token={data} />
              <DiscreteTokenPanel token={data} />
              <MysteryTokenPanel token={data} onRefreshPage={refetch as any} />
              <GenesTokenPanel token={data} />
              <TraitTokenPanel token={data} />
              <DismantleTokenPanel token={data} />
              <LendTokenPanel token={data} />
              {/*<IpfsTokenPanel token={data} />*/}
              {/*<OpenSeaTokenPanel token={data} />*/}
            </>
          )}
        </MuiGrid>
      </MuiGrid>

      {data.id && <TokenHistory token={data} />}
    </Fragment>
  );
};
